module.exports = __webpack_public_path__ + "static/img/mid_arrivals.60545da.png";